import * as messageService from "../../services/message.service";
import * as financierService from '../../services/financier.service';


const state = {
    financierAll:[],
    financierAllActive:[],
    financierAllDropdownList:[],
    financierDropdownList:[],
    financierPaginateData:{},
    financierPaginate:{}
};

const getters = {
    getFinancierAll:state => (state.financierAll),
    getFinancierAllActive:state => (state.financierAllActive),
    getFinancierAllDropdownList:state => (state.financierAllDropdownList),
    getFinancierDropdownList:state => (state.financierDropdownList),
    getFinancierPaginateData:state => (state.financierPaginateData),
    getFinancierPaginate:state => (state.financierPaginate),
};

const actions = {
    async fetchFinancierAll({ commit } ){
        try {
            const response = await financierService.all();
            commit('setFinancierAll', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
    async fetchFinancierAllActive({ commit } ){
        try {
            const response = await financierService.allActive();
            commit('setFinancierAllActive', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },

    async fetchFinancierAllDropdownList({ commit } ){
      try {
          const response = await financierService.dropdownAllList();
          commit('setFinancierAllDropdownList', response.data);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
      }
    },

    async fetchFinancierDropdownList({ commit } ){
      try {
          const response = await financierService.dropdownList();
          commit('setFinancierDropdownList', response.data);
      } catch (error) {
          const obj = {
              "type":'error',
              "title":error.response.data.error.name,
              "text":error.response.data.error.message,
              "footer":'Error code: ' + error.response.data.error.statusCode,
          }

          messageService.fnSweetAlertDisplay(obj);
      }
    },

  async fetchFinancierPaginate({ commit }, obj){
    commit('setFinancierPaginate', obj)
    try {
        const response = await financierService.listPage(obj);
        commit('setFinancierPaginateData', response.data);

    } catch (error) {
        console.log('something wrong - fetchFinancierPaginate', error);
    }
  },


};

const mutations = {
    setFinancierAll:(state, res) => (
        state.financierAll =  res
    ),
    setFinancierAllActive:(state, res) => (
        state.financierAllActive =  res
    ),
    setFinancierAllDropdownList:(state, res) => (
      state.financierAllDropdownList =  res
    ),
    setFinancierDropdownList:(state, res) => (
      state.financierDropdownList =  res
    ),
    setFinancierPaginate:(state, res) => (
      state.financierPaginate =  res
    ),
    setFinancierPaginateData:(state, res) => (
      state.financierPaginateData =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}
